export const borderColors = {
  default: '#A3A3A3',
  hover: '#525252',
};

export const borderRadius = '4px';

export const fontSizes = {
  xlarge: '1.6rem',
  large: '1.6rem',
  medium: '1.4rem',
  small: '1.2rem',
};

export const paddings = {
  xlarge: '1.6rem',
  large: '1.2rem',
  medium: '0.8rem 1.2rem',
  small: '0.4rem 0.8rem',
};

export const rightPaddings = {
  xlarge: '4.8rem',
  large: '4.0rem',
  medium: '3.8rem',
  small: '3.2rem',
};

export const iconSize = {
  xlarge: '2.4rem',
  large: '2.4rem',
  medium: '2.0rem',
  small: '2.0rem',
};

export const iconRightDistance = {
  xlarge: '1.6rem',
  large: '1.2rem',
  medium: '1.0rem',
  small: '0.6rem',
};

export const iconTopDistance = {
  xlarge: '1.2rem',
  large: '1.2rem',
  medium: '0.8rem',
  small: '0.8rem',
};

export const inputSizesClasses = ['xlarge', 'large', 'medium', 'small'];

export const textareaSize = {
  xlarge: '104px',
  large: '96px',
  medium: '88px',
  small: '80px',
};

export const checkboxSizes = {
  large: '24px',
  medium: '20px',
  small: '16px',
};
